import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { DataGridModule } from '@portal-core/ui/grid/components/data-grid/data-grid.module';
import { GridComponentModule } from '@portal-core/ui/grid/components/grid/grid.module';
import { ContextMenuItemsModule } from '@portal-core/ui/grid/directives/context-menu-items/context-menu-items.module';
import { EmptyGridModule } from '@portal-core/ui/grid/directives/empty-grid/empty-grid.module';
import { ExpandedRowDetailModule } from '@portal-core/ui/grid/directives/expanded-row-detail/expanded-row-detail.module';
import { GridCellModule } from '@portal-core/ui/grid/directives/grid-cell/grid-cell.module';
import { GridHeaderMenuModule } from '@portal-core/ui/grid/directives/grid-header-menu/grid-header-menu.module';
import { HelpGridModule } from '@portal-core/ui/grid/directives/help-grid/help-grid.module';
import { ScrollToOnLoadModule } from '@portal-core/ui/grid/directives/scroll-to-on-load/scroll-to-on-load.module';

@NgModule({
  exports: [
    ContextMenuItemsModule,
    DataGridModule,
    EmptyGridModule,
    ExpandedRowDetailModule,
    GridCellModule,
    GridComponentModule,
    GridHeaderMenuModule,
    HelpGridModule,
    MatMenuModule,
    ScrollToOnLoadModule
  ]
})
export class GridModule { }
